/** Métadonnées produit — alignées sur docs/application-praticien/README.md */
export const APP_NAME = 'Ligam';
/** Praticien connecté (démo). */
export const PRACTITIONER_NAME = 'Dr. Camille Moreau';
export const APP_DESCRIPTION =
  'Application de gestion de cabinet orthodontique pour praticiens et assistantes.';
export const APP_LANG = 'fr';
export const APP_THEME_COLOR = '#4f46e5';
